// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__footer___vniFa","footer_compressed":"Footer-module__footer_compressed___GmLJB","footer_opened":"Footer-module__footer_opened___KMC1i"};